module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Movie-Lane2-6164cdb52e27f6ea2e6db81212273dd4.svg";